import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @description Validador personalizado para asegurar que un valor sea un número entero
 * @function integerValidator
 * @returns {ValidatorFn} Función validadora que verifica si el valor es un entero
 *
 * @example
 * // Uso en un FormControl
 * const control = new FormControl('', [integerValidator()]);
 *
 * // Uso en un FormGroup
 * const form = new FormGroup({
 *   quantity: new FormControl('', [integerValidator()])
 * });
 *
 * @remarks
 * - Acepta solo números enteros positivos (ej: "123")
 * - No acepta decimales (ej: "123.45")
 * - No acepta caracteres no numéricos
 * - Retorna null si el valor es válido
 * - Retorna { integer: true } si el valor es inválido
 */
export function integerValidator(): ValidatorFn {
  /**
   * @param {AbstractControl} control - Control del formulario a validar
   * @returns {ValidationErrors | null} Objeto de error si la validación falla, null si es válida
   */
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Si no hay valor, se considera válido
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Valida que sean solo dígitos usando expresión regular
    const isValid = /^[0-9]+$/.test(value);
    return isValid ? null : { integer: true };
  };
}
